<template>
    <div class="">
     <div id="mapContainer"></div>
    </div>
</template>

<script>
import {MyTMap} from "@/utils/map";
export default {
    data() {
        return {}
    },
    created(){
       
    },
    mounted() {
        this.initMap();
    },
    methods: {
        initMap(){
            let that=this;
            this.TMap=new MyTMap();
            this.TMap.initMap();
            this.TMap.onMapClick(function(e){
                that.TMap.removeAllGraphic();
                let {lng,lat}=e.latLng
                let obj={ //点标注数据数组
                    "id": "demo",
                    "styleId": "marker",
                    "position": new TMap.LatLng(lat, lng),
                    "properties": {
                        "title": "marker"
                    }
                }
                that.TMap.addMarker([obj],{src:'/src/assets/arrow.png'})
            });
        }
    },
}
</script>

<style scoped>

</style>
